import { StrictDict } from '../../utils';

/* eslint-disable import/prefer-default-export */
export const blockTypes = StrictDict({
  html: 'html',
  video: 'video',
  problem: 'problem',
  // ADDED_EDITORS GO BELOW
});
